import { CognitoUser, CognitoUserAttribute } from 'amazon-cognito-identity-js';
import { httpMethods } from 'enums';
import { Http } from 'library';
import { EntUserPool, UserPool } from './UserPool';
import api from 'api/client';

import * as Endpoints from 'constants/endpoints.constant';

/* eslint-disable */
class SignUpService {
  /**
   * Login
   * @param payload
   */
  static async signup(payload: any) {
    const attributesToBeAdded = [
      {
        Name: 'family_name',
        Value: payload.name,
      },
      {
        Name: 'given_name',
        Value: payload.name,
      },
      {
        Name: 'phone_number',
        Value: payload.mobile,
      },
      {
        Name: 'email',
        Value: payload.email,
      },
    ];
    const attrList: Array<CognitoUserAttribute> = attributesToBeAdded.map(
      (attr) => new CognitoUserAttribute(attr)
    );
    return new Promise(async (resolve, reject) => {
      UserPool.signUp(
        payload.mobile,
        payload.password,
        attrList,
        null,
        (err, result) => {
          if (err) {
            reject(err);
            return;
          }
          if (result && result.user) {
            resolve(result);
          }
        }
      );
    });
  }
  /**
   * B2B Signup
   * @param username
   * @param password
   */
  static async entSignUp(payload: any) {
    const attributesToBeAdded = [
      {
        Name: 'family_name',
        Value: payload.name,
      },
      {
        Name: 'given_name',
        Value: payload.name,
      },
      {
        Name: 'phone_number',
        Value: payload.mobile,
      },
      {
        Name: 'email',
        Value: payload.email,
      },
    ];
    const attrList: Array<CognitoUserAttribute> = attributesToBeAdded.map(
      (attr) => new CognitoUserAttribute(attr)
    );
    return new Promise(async (resolve, reject) => {
      EntUserPool.signUp(
        payload.pan,
        payload.password,
        attrList,
        null,
        (err, result) => {
          if (err) {
            reject(err);
            return;
          }
          if (result && result.user) {
            resolve(result);
          }
        }
      );
    });
  }

  static getGstns = async (data) =>
    Http.setMethod(httpMethods.post)
      .setData(data)
      .setUrl(Endpoints.B2B_GSTN_LIST)
      .request();
  static getGstinDetails = async (data) =>
    Http.setMethod(httpMethods.post)
      .setData(data)
      .setUrl(Endpoints.B2B_GSTN)
      .request();

  static enterpriseSignUp = async (data) =>
    Http.setMethod(httpMethods.post)
      .setData(data)
      .setUrl(Endpoints.B2B_SIGNUP)
      .request();

  /**
   * sendOTP
   * @param username
   */
  static async sendOTP(username: any) {
    const user: CognitoUser = new CognitoUser({
      Username: username,
      Pool: EntUserPool,
    });

    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async (resolve, reject) => {
      user.resendConfirmationCode(function (err, result) {
        if (err) {
          reject(err);
          return;
        }
        resolve(result);
      });
    });
  }

  /**
   * verifyOTP
   * @param username
   * @param otp
   */
  static async verifyOTP(username: any, otp: any) {
    const user: CognitoUser = new CognitoUser({
      Username: username,
      Pool: EntUserPool,
    });
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async (resolve, reject) => {
      user.confirmRegistration(otp, true, function (err, result) {
        if (err) {
          reject(err);
          return;
        }
        resolve(result);
      });
    });
  }

  static sendOTPToEmail = async (token: any = '', accessToken: any = '') =>
    Http.setMethod(httpMethods.get)
      .setUrl(`${Endpoints.SEND_OTP}`)
      .setToken(token)
      .setAccessToken(accessToken)
      .request();
  static verifyMailOtp = async (
    data: any,
    token: any = '',
    accessToken: any = ''
  ) =>
    Http.setMethod(httpMethods.post)
      .setData(data)
      .setUrl(`${Endpoints.VERIFY_OTP}`)
      .setToken(token)
      .setAccessToken(accessToken)
      .request();
}

export default SignUpService;
